import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

// Pre-pago config (Fase 6 - see smartpay-dashboard services/branchoffice.js): prepay_tables_enabled
// turns on the "Generar QR para pedir y pagar" flow for this branch's tables (the checkbox next to
// this had no UI anywhere in this dashboard before this modal - see the "Generar QR" button on each
// table row, which stays reachable from the POS regardless, this only gates whether the FEATURE is
// considered enabled for the branch). prepay_name_mode controls whether the ecommerce QR entry page
// asks the customer for their name at all.
const PrepaySettingsModal = ({ show, onHide, initialValues, onSave, saving }) => {
    const [enabled, setEnabled] = useState(Boolean(initialValues?.prepay_tables_enabled));
    const [nameMode, setNameMode] = useState(initialValues?.prepay_name_mode || 'REQUIRED');

    useEffect(() => {
        if (!show) return;
        setEnabled(Boolean(initialValues?.prepay_tables_enabled));
        setNameMode(initialValues?.prepay_name_mode || 'REQUIRED');
    }, [show, initialValues]);

    const handleSave = () => {
        onSave?.({ prepay_tables_enabled: enabled, prepay_name_mode: nameMode });
    };

    return (
        <Modal show={show} onHide={onHide} centered size="md">
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: '1rem', fontWeight: 700 }}>
                    Pedido en mesa - Prepago
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Check
                        type="checkbox"
                        id="prepay-tables-enabled"
                        label="Habilitar pedidos con pago anticipado (QR reutilizable)"
                        checked={enabled}
                        onChange={(e) => setEnabled(e.target.checked)}
                    />
                    <Form.Text className="text-muted">
                        Permite generar desde el POS un QR de mesa reutilizable con el que los clientes piden y pagan
                        sin esperar autorizacion del mesero.
                    </Form.Text>
                </Form.Group>

                <Form.Group>
                    <Form.Label>Solicitar nombre al escanear el QR</Form.Label>
                    <Form.Select value={nameMode} onChange={(e) => setNameMode(e.target.value)} disabled={!enabled}>
                        <option value="REQUIRED">Requerido</option>
                        <option value="OPTIONAL">Opcional</option>
                        <option value="DISABLED">Deshabilitado</option>
                    </Form.Select>
                    <Form.Text className="text-muted">
                        Requerido bloquea el paso hasta que el cliente escriba su nombre; Opcional lo deja pasar en
                        blanco; Deshabilitado no muestra el campo en absoluto.
                    </Form.Text>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onHide} disabled={saving}>Cancelar</Button>
                <Button onClick={handleSave} disabled={saving}>{saving ? 'Guardando...' : 'Guardar'}</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PrepaySettingsModal;
